<template>
  <div class="smart_config">
    <crumb-tit>
      <span
        slot="breadTit"
      >
        {{ $t('message["1246"]') }}
      </span>
      <span
        slot="secondTit"
      >
        {{ $t('message["1246"]') }}
      </span>
    </crumb-tit>
    <tab-title
      :data="tabData"
      :selected="selected"
      @change="toChangeTab"
    />
    <form-config
      v-if="selected === 'formConfig'"
    />
    <smart-intercept v-if="selected === 'Intercept'" />
  </div>
</template>

<script type="text/ecmascript-6">
import tabTitle from '@/pc/smartForm/components/Tab'
import CrumbTit from '@/components/pc/config/CrumbTit'
import formConfig from './FormConfig'
import smartIntercept from './SmartIntercept'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    tabTitle,
    formConfig,
    smartIntercept,
    CrumbTit
  },
  data () {
    return {
      selected: 'formConfig',
      tabData: [{
        fieldkey: 'formConfig',
        fieldname: this.$t('message["59"]'),
        show: true
      }, {
        fieldkey: 'Intercept',
        fieldname: this.$t('message["1606"]'),
        show: true
      }]
    }
  },
  computed: {
    ...mapState('config/smart', ['baseConfig', 'loading']),
    ...mapState(['baseinfo'])
  },
  watch: {
    baseinfo (val) {
      const { projectname, comname } = val
      this.$route.meta.title = `${this.$t('message["1246"]')}-${projectname}-${comname}`
    }
  },
  async created () {
    await this.getFormConfigInfo()
  },
  methods: {
    ...mapActions('config/smart', ['getFormConfigInfo']),
    toChangeTab (value) {
      // console.log(e)
      this.$set(this._data, 'selected', value)
    }
  }
}
</script>

<style scoped lang="scss">
.smart_config {
  box-sizing: border-box
}
</style>
